<template>
  <div>
    <base-tab :tabs="tabsData" @tab-click="tabSelected"></base-tab>
    <keep-alive>
      <component :is="isComponent"
                 ref="orderList">
      </component>
    </keep-alive>
  </div>
</template>

<script>
import PwdEdit from './PwdEdit'
import UserEdit from './UserEdit'

export default {
  name: 'SysIndex',
  components: {
    'pwd-edit': PwdEdit,
    'user-edit': UserEdit
  },
  data () {
    return {
      isComponent: 'user-edit',
      tabsData: [
        {id: 'user-edit', name: '个人资料', badge: 0},
        {id: 'pwd-edit', name: '修改密码', badge: 0}
      ]
    }
  },
  methods: {
    tabSelected (tab) {
      this.isComponent = this.tabsData[tab.index].id
    }
  }

}
</script>

<style scoped>

</style>
